module.exports = __webpack_public_path__ + "img/Decoder-5star-badge.261c262.png";